import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class PinnedListWithImages {
  constructor(container) {
    this.container = container;
    this.colImages = container.querySelector('.col-images');
    this.imageList = this.colImages.querySelector('ul');

    if (!this.colImages || !this.imageList) return;

    this.mount();
  }

  mount() {
    ScrollTrigger.matchMedia({
      // Desktop — vertical scroll
      '(min-width: 992px)': () => {
        const scrollAmount = this.colImages.scrollHeight - window.innerHeight;

        gsap.to(this.colImages, {
          y: -scrollAmount,
          ease: 'none',
          scrollTrigger: {
            trigger: this.container,
            start: 'top top',
            end: `+=${scrollAmount}`,
            scrub: true,
            pin: true,
            invalidateOnRefresh: true,
          },
        });
      },
    });
  }
}
